// Customer / driver details › Bank details (wave 3, W2_Portal_BookingDetails
// look): one card of label / value rows. Bank name, code and account number
// come from the user record the details page hands in (no reads here) and
// are hidden in demo mode, as before. "← Back" is the page's own (top left).
import React from 'react';
import Box from '@mui/material/Box';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DetailCard, InfoRow, calmCaps } from '../components/modern';

export const BankDetails = (props) => {
  const { t, i18n } = useTranslation();
  const settings = useSelector((state) => state.settingsdata.settings);
  const allowPrivate = !!(settings && settings.AllowCriticalEditsAdmin);
  const user = props.data || {};
  const noData = t('no_data_available', { defaultValue: 'No data available' });
  const valueOf = (raw) => (raw ? (allowPrivate ? raw : t('hidden_demo')) : noData);

  return (
    <Box dir={i18n.dir()}>
      <DetailCard icon={<AccountBalanceOutlinedIcon />} hue="success" title={calmCaps(t('bankDetails', { defaultValue: 'Bank details' }))}>
        <InfoRow label={t('bankName')}>{valueOf(user.bankName)}</InfoRow>
        <InfoRow label={t('bankCode')}>{valueOf(user.bankCode)}</InfoRow>
        <InfoRow label={t('bankAccount')}>
          <Box component="span" sx={{ fontVariantNumeric: 'tabular-nums' }}>
            {valueOf(user.bankAccount)}
          </Box>
        </InfoRow>
      </DetailCard>
    </Box>
  );
};
